import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { User } from 'src/app/common/state/user/user.model';
import { UserState } from 'src/app/common/state/user/user.state';
import { CommentModelDTO } from '../../dtos/comment.dto';
import { CommentsService } from '../../services/comments/comments.service';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  standalone: false,
})
export class CommentsComponent {
  @Input() refTable: string;

  @Input() refTableId: number;

  @Input() commentList: CommentModelDTO[] = [];

  @Input() hideCommentSubmissonInput = false;

  @Output() readonly commentDeleted = new EventEmitter<boolean>();

  newComment: CommentModelDTO = new CommentModelDTO();

  currentUser: User;

  constructor(private commentsService: CommentsService, private store: Store) {
    this.currentUser = this.store.selectSnapshot(UserState.getUser) as User;
  }

  saveComment() {
    this.newComment.ref_table = this.refTable;
    this.newComment.ref_table_id = this.refTableId;
    this.commentsService.saveComment(this.newComment).subscribe((result) => {
      if (result.item) {
        this.commentList.push(result.item);
        this.newComment.comment = '';
      }
    });
  }

  deleteComment(comment: CommentModelDTO) {
    this.commentsService.deleteComment(comment).subscribe((response) => {
      if (response) {
        this.commentList = this.commentList.filter(
          (item) => item.id !== comment.id
        );
        this.commentDeleted.emit(true);
      }
    });
  }
}
